import {Component, inject}                       from '@angular/core';
import {FormsModule}                             from '@angular/forms';
import {BodyRecordLogIntf, BodyRecordSumIntf}    from '@djsharkk/logr-types';
import {v4 as uuidv4}                            from 'uuid';
import {MenuCrudPanelContentBase}                from '../../menu-crud-panel-content-base';
import {MenuCrudPanelBodyService}                from '../../menu-crud-panel-top/menu-crud-panel-body-top/menu-crud-panel-body.service';
import {MenuCrudPanelBotComponent, PanelBtnIntf} from '../menu-crud-panel-bot.component';

@Component({
			   selector   : 'app-menu-crud-panel-body-bot',
			   imports    : [
				   MenuCrudPanelBotComponent,
				   FormsModule
			   ],
			   templateUrl: './menu-crud-panel-body-bot.component.html',
			   styleUrl   : './menu-crud-panel-body-bot.component.css'
		   })
export class MenuCrudPanelBodyBotComponent extends MenuCrudPanelContentBase<BodyRecordLogIntf, BodyRecordSumIntf> {
	svcMenuCrudBody = inject(MenuCrudPanelBodyService)


	btnsL: PanelBtnIntf[] = [
		{
			text: 'Add',
			icon: 'plus',
			func: async () => {
				await this.svcMenuCrudBody.addRecord();
				this.svcMenuCrudBody.selected = [];
				this.svcMenuCrudBody.note = '';
			},
			uuid: uuidv4()
		}
	]

	constructor() {
		super('body', true)
	}


}
